<a
  (click)="this.emitLanguage()"
  (keydown.enter)="this.emitLanguage()"
  tabindex="0"
  [attr.data-dm]="
    {
      data_type: 'cta',
      item_name: 'language-selector language-item',
      country: baseSiteCode,
      language: languageIsoCode,
    } | json
  "
>
  {{ language.nativeName }}
</a>
